import { Button } from "@design-lab/shared/ui/design-system/Button";
import { Minus, Plus } from "lucide-react";

type ZoomControlsProps = {
  zoomPercentage: number;
  canZoomIn: boolean;
  canZoomOut: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export function ZoomControls({
  zoomPercentage,
  canZoomIn,
  canZoomOut,
  onZoomIn,
  onZoomOut
}: ZoomControlsProps) {
  return (
    <div className="bg-background absolute right-4 top-4 z-10 flex h-14 w-fit items-center gap-2 rounded-md border p-1">
      <Button
        data-testid="zoom-out-button"
        variant="icon"
        className="h-full w-10 rounded-md border-none p-0"
        onPress={onZoomOut}
        isDisabled={!canZoomOut}
        aria-label="Zoom out"
      >
        <Minus className="size-4" />
      </Button>

      <div
        role="status"
        aria-label="Zoom percentage"
        className="bg-background flex h-full w-16 select-none items-center justify-center rounded-md border px-4 text-sm font-medium text-gray-700"
      >
        {zoomPercentage}%
      </div>

      <Button
        data-testid="zoom-in-button"
        variant="icon"
        className="h-full w-10 rounded-md border-none p-0"
        onPress={onZoomIn}
        isDisabled={!canZoomIn}
        aria-label="Zoom in"
      >
        <Plus className="size-4" />
      </Button>
    </div>
  );
}
